<template>
<span>
  <vx-tooltip :text="tooltipText" delay="0.5s" class="text-center mr-1">
    <feather-icon v-if="done" :class="actionElementCss" icon="CheckCircleIcon" svgClasses="h-5 w-5" @click.stop="$emit('removeDay')" />
    <feather-icon v-else :class="actionElementCss" class="font-bold" :icon="notDoneIcon" :svgClasses="isToday ? 'h-5 w-5' : 'h-5 w-5'" @click.stop="$emit('addDay')" />
  </vx-tooltip>

</span>
</template>

<script>

export default {
  components: {
  },
  props: ['done', 'day', 'isToday'],
  data () {
    return {
      innerModel: [],
    }
  },
  watch: {
    'value': {
      immediate: true,
      handler (value) {
        this.innerModel = value
      }
    },
    'innerModel': {
      immediate: false,
      handler (value) {
        this.$emit('input', value)
      }
    },
  },
  computed: {
    notDoneIcon () {
      return this.isToday ? 'CircleIcon' : 'MinusIcon'
    },
    tooltipText () {
      return this.$options.filters.weekDaySpecial(this.day)
    },
  },
  methods: {

  }
}
</script>

<style>

.vs-tooltip.vs-tooltip-top:after {
    bottom: -6px;
    right: -20px;
}
<style>
